export default "__VITE_ASSET__92299757__"